import { graphql } from "../gql";

export const updateDirectoryMutationDoc = graphql(`
  mutation updateDirectory($id: ID!, $input: UpdateDirectoryInput!) {
    updateDirectory(id: $id, input: $input) {
      ...DirectoryFragment
    }
  }
`);
